import * as HttpUtils from 'utils/HttpUtils'
import FormConst from 'constants/FormConst'
import URLConst from 'constants/URLConst'
import { runInAction } from "mobx"
import { makeAutoObservable } from "mobx"

/*
 * Module - UserStore.js
 *
 * Description : 
 *
 * 작성자 : Choi young ho. 
 * Created on Fri Jan 21 2022
 * Copyright (c) 2022 Renewhouse corp
 */
export default class UserStore {

    constructor(root) {
        this.root = root;
        this.initState();
        makeAutoObservable(this)
    }

    initState = () => {
        this.userInfo = null;    
    }

    /**
     * 사용자 정보를 
     * 설정 합니다. 
     * @param {*} userInfo 
     */
    setUserInfo = (userInfo) => {
        this.userInfo = userInfo;
    }

    /**
     * 사용자 정보 
     * 갱신을 요청 합니다. 
     */
    doRefreshUserInfo = async () => {
        let param = {};
        let result = await HttpUtils.doPostFormData(URLConst.ADMIN_INFO_DATA_URL, param);

        runInAction(() => {
            this.setUserInfo(result[FormConst.OBJECT_FIELD]);
        });
        return result;
    }
}